


// src/redux/store.js
import { configureStore } from "@reduxjs/toolkit";
import { cartReducer } from "./slices/cartSlice";


export const store = configureStore({
  reducer: cartReducer,
   
  
  
  
})
